import React, { useState, useEffect } from 'react';
import { MDBCard, MDBCardBody, MDBProgress, MDBProgressBar } from 'mdb-react-ui-kit';

const ExportProgress = ({title, current, total, show}) => {

    const [currentProgress, setCurrentProgress] = useState(current);
    const [totalProgress, setTotalProgress] = useState(total);

    useEffect(() => {
        setCurrentProgress(current);
    }, [current]);

    useEffect(() => {
        setTotalProgress(total);
    }, [total]);

    if (!show) return null; 
    else return (
    <MDBCard className="position-fixed top-0 end-0 m-3" style={{ zIndex: 1050, width: '300px' }}>
      <MDBCardBody className="p-3">
        <h6 className="mb-2">{title}</h6>
        <div className="text-muted small mb-2">
          Processing records: {currentProgress} of {totalProgress}
        </div>
        <MDBProgress height="10">
          <MDBProgressBar 
            width={Math.round(currentProgress / totalProgress) * 100} 
            valuemin={0} 
            valuemax={100}
          />
        </MDBProgress>
        <div className="text-end small mt-1">
          {Math.round((currentProgress / totalProgress) * 100)}% complete
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default ExportProgress; 